import React from "react";
import Layout from "../layouts";
import { NavLink } from "react-router-dom";
import LoginForm from "../components/login";

const Login = () => {
    return (
        <React.Fragment>
            <Layout>                
                <LoginForm />
                <p>Anda belum terdaftar?, silahkan daftar terlebih dahulu</p>
                <NavLink
                    to={process.env.PUBLIC_URL + "/registration"}
                >
                    Register
                </NavLink>
            </Layout>
        </React.Fragment>

    )
}

export default Login;